module.exports = __webpack_public_path__ + "static/media/appstore-1f.450f8d2d.png";